import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ProvidersService } from '../../../providers.service';

@Component({
  selector: 'app-update-pricelist-smart',
  template: '<app-update-pricelist [productDetails]="productDetails" [producttypes]="producttypes" [plantypes]="plantypes" [providerService]="providerService"  [transactionTypes]="transactionTypes" [codeGroups]="codeGroups" [carrierTypes]="carrierTypes" [serviceCountries]="serviceCountries" [responseTypes]="responseTypes"  [allProviders]="allProviders"></app-update-pricelist>',
  styles: [
  ]
})
export class UpdatePricelistSmartComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  // providers: any;
  producttypes: any;
  plantypes: any;
  providerService: any;
  transactionTypes: any;
  codeGroups: any;
  carrierTypes: any;
  productDetails: [];
  serviceCountries: any;
  responseTypes: any;
  productId: number;
  allProviders: any;

  constructor(private providersService: ProvidersService, private activeRoute: ActivatedRoute) {
    super();
    this.getAllProductServiceData();
  }

  getAllProductServiceData() { 
    this.productId = this.activeRoute.snapshot.params.id;
    let productDetails = this.providersService.getProductDetails(this.productId);
    let allproducttypes = this.providersService.getallproducttypes();
    let planTypes = this.providersService.getallplantypes();
    let providerService = this.providersService.getallProviderService();
    let responseTypes = this.providersService.getallresponseTypes();
    let transactionTypes = this.providersService.getTransactionTypes();
    let codeGroups = this.providersService.getcodeGroups();
    let carrierTypes = this.providersService.getCarriers();
    let allProviders = this.providersService.getallproviders()
    let serviceCountries = this.providersService.getserviceCountry();

    forkJoin([productDetails, allproducttypes, planTypes, providerService, responseTypes, transactionTypes, codeGroups, carrierTypes, allProviders, serviceCountries]).subscribe(
      res => {
        this.productDetails = res[0].data;
        this.producttypes = res[1].data;
        this.plantypes = res[2].data;
        this.providerService = res[3].data;
        this.responseTypes = res[4].data;
        this.transactionTypes = res[5].data;
        this.codeGroups = res[6].data;
        this.carrierTypes = res[7].data;
        this.allProviders = res[8].data
        this.serviceCountries = res[9].data;
      }
    );
  }


  ngOnInit(): void {
    super.ngOnInit();

  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
